import style from "./style";
import DoughnutChart from "../doughnutChart";
import PreLoader from "../preLoader";

const options = {
  maintainAspectRatio: true,
  tooltips: {
    callbacks: {
      label: function (tooltipItem, data) {
        var tooltipValue =
          data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
        return parseInt(tooltipValue).toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      },
    },
  },
};

const PieChart = (props) => {
  if (props.loading) return <PreLoader />;
  if (
    !props.data.datasets ||
    !props.data.datasets.length ||
    !props.data.datasets[0].data.length
  )
    return <div />;
  return (
    <div className={style.sectionsWrapper} style={{ display: "block" }}>
      <div className={style.chartWrapper}>
        <DoughnutChart
          width={10}
          height={10}
          data={props.data}
          options={options}
        />
        <div className={style.legendWrapper}>
          <b>{`$${(props.totalValue / 1000000).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}M`}</b>
          <span>{props.title}</span>
        </div>
      </div>
    </div>
  );
};

export default PieChart;



// WEBPACK FOOTER //
// ./components/pie-chart/index.js